// externals
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as dealXgDetailsSelectors from '@makemydeal/dr-dash-store/selectors/dealXgDetailsSelectors';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { ACTIVITY_NAME_INCENTIVES } from '@makemydeal/dr-dpm-client';

// components
import DealActivityCard from '../DealActivityCard.interstate';

const name = 'incentives';

const IncentivesCard = () => {
    const dispatch = useDispatch();
    const totalRebates = useSelector(offerReduxSelectors.getAppliedIncentivesTotalForNonDealerCash);
    const completed = useSelector(offerReduxSelectors.getAppliedIncentivesForNonDealerCash).length > 0;
    const cardValue = useMemo(() => formatDollarsAndCents(totalRebates), [totalRebates]);

    const incentivesDpmState = useSelector((state: StateTree) =>
        dealXgDetailsSelectors.getDpmStateByActivity(state, ACTIVITY_NAME_INCENTIVES)
    );

    const handleCardClick = () => {
        // Dispatch analytics action
        if (completed) dispatch(interactionAnalyticsActionCreators.programsAndIncentivesEditLink());
        else dispatch(interactionAnalyticsActionCreators.programsAndIncentivesStartLink());

        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Incentives));
    };

    return (
        <DealActivityCard
            dpmState={incentivesDpmState}
            name={name}
            cardValue={cardValue}
            completed={completed}
            showCardAnchor={true}
            action={handleCardClick}
        />
    );
};

export default IncentivesCard;
